<template>
  <div>
    <div class="import-section">
      <h3>¿Quién eres?</h3>
      <b-form>
        <b-row>
          <b-col sm="12" md="4">
            <label class="mr-sm-2" for="contactType">Particular/Empresa*</label>
            <b-form-select
              id="contactType"
              v-model="contact.contactType"
              :options="contactTypes"
              :state="states['contactType']"
            ></b-form-select>
          </b-col>
          <b-col sm="12" md="4">
            <label class="mr-sm-2" for="name">Nombre*</label>
            <b-form-input
              id="name"
              v-model="contact.name"
              type="text"
              placeholder="Nombre"
              trim
              :state="states['name']"
            ></b-form-input>
          </b-col>
          <b-col v-if="contact.contactType == 1" sm="12" md="4">
            <label class="mr-sm-2" for="lastName">Apellidos</label>
            <b-form-input
              id="lastName"
              v-model="contact.lastName"
              type="text"
              placeholder="Apellidos"
              trim
            ></b-form-input>
          </b-col>
          <b-col v-if="contact.contactType == 2" sm="12" md="4">
            <label class="mr-sm-2" for="vatNumber">VAT</label>
            <b-form-input
              id="vatNumber"
              v-model="contact.vatNumber"
              type="text"
              placeholder="VAT"
              trim
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6">
            <label class="mr-sm-2" for="identityDocumentType">Tipo de Documento</label>
            <b-form-select
              id="identityDocumentType"
              v-model="contact.identityDocumentType"
              :options="documentTypeTypes"
            >
              <option></option>
            </b-form-select>
          </b-col>
          <b-col sm="12" md="6">
            <label class="mr-sm-2" for="identityDocument">Documento</label>
            <b-form-input
              id="identityDocument"
              v-model="contact.identityDocument"
              type="text"
              placeholder="Documento"
              trim
            >
              <option></option>
            </b-form-input>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <!-- Contact Method -->
    <div class="import-section">
      <h3>¿Cómo contactamos contigo?</h3>
      <b-form>
        <!-- Phone contact Type -->
        <b-row>
          <b-col sm="12" md="6">
            <label class="mr-sm-2" for="contactMethod">Teléfono*</label>
            <b-form-input
              id="contactMethod"
              v-model="contactMethod.contactMethod"
              type="text"
              placeholder="Teléfono"
              trim
              :state="states['contactMethod']"
            ></b-form-input>
          </b-col>
          <b-col sm="12" md="6">
            <label class="mr-sm-2" for="mailContactMethod">Email*</label>
            <b-form-input
              id="mailContactMethod"
              v-model="mailContactMethod.contactMethod"
              type="text"
              placeholder="Email"
              trim
              :state="states['mailContactMethod']"
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
      </b-form>
    </div>
    <!-- Contact Process-->
    <div class="import-section">
      <h3>¿Qué estás buscando?</h3>
      <b-form>
        <b-row>
          <b-col sm="12" md="6">
            <label class="mr-sm-6" for="process">Tipo de Propiedad</label>
            <b-form-select
              id="process"
              v-model="process.propertyType"
              :options="propertyTypes"
              :state="states['propertyType']"
            ></b-form-select>
          </b-col>
          <b-col sm="12" md="6">
            <label class="mr-sm-6" for="process">Proceso</label>
            <b-form-select
              id="process"
              v-model="process.process"
              :options="processTypes"
              :state="states['process']"
            ></b-form-select>
          </b-col>
          <b-col sm="12" md="6">
            <label class="mr-sm-6" for="desiredPrice">Precio Deseado</label>
            <b-form-input
              id="desiredPrice"
              v-model="process.desiredPrice"
              type="text"
              placeholder="Precio Deseado"
              :state="states['desiredPrice']"
              trim
            ></b-form-input>
          </b-col>
        </b-row>
        <!-- <Requirements
          :process="process.process"
          :propertyType="process.propertyType"
          :requirements="process.contactProcessRequirements"
          @delete="(index) => {process.contactProcessRequirements.splice(index,1);}"
          @add="(requirement) => {process.contactProcessRequirements.push(requirement);}"
        />-->
      </b-form>
    </div>
    <div class="import-section">
      <b-row>
        <b-col>
          <b-form-checkbox
            style="float:left;"
            id="accept-terms"
            v-model="terms"
            name="accept-terms"
            value="accepted"
            unchecked-value="not_accepted"
          >Acepto los términos de servicio y condiciones</b-form-checkbox>

          <router-link
            style="float:left;margin-left:6px;"
            to="/lopd"
            target="_blank"
          >Más información</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>* Campos Obligatorios</p>
        </b-col>
      </b-row>
    </div>
    <div class="button-container">
      <b-row>
        <b-col>
          <button class="btn btn-send btn-primary" @click="importContact" :disabled="sending">
            <template v-if="sending">
              <b-spinner style="width: 1.3rem; height: 1.3rem;color:white;" label="Large Spinner"></b-spinner>
            </template>
            <template v-else>Enviar</template>
          </button>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="importSuccessMessage !== ''"
      class="import-result-displayer-success"
    >{{importSuccessMessage}}</div>
    <div
      v-if="importErrorMessage !==''"
      class="import-result-displayer-error"
    >{{importErrorMessage}}</div>
  </div>
</template>

<script>
import ImportRepository from "@/repositories/ImportRepository";

export default {
  name: "Import",
  components: {},
  data() {
    return {
      sending: false,
      mandatoryFields: {
        contact: ["contactType", "name"],
        contactMethod: ["contactMethod"],
        mailContactMethod: ["contactMethod"],
        process: ["propertyType", "process", "desiredPrice"]
      },
      states: {
        contactType: null,
        name: null,
        contactMethodType: null,
        prefix: null,
        contactMethod: null,
        mailContactMethodType: null,
        mailContactMethod: null,
        propertyType: null,
        process: null,
        desiredPrice: null
      },
      defaults: {
        contact: {
          contactType: 1,
          source: 5
        },
        contactMethod: {
          prefix: "+34",
          contactMethodType: 1
        },
        mailContactMethod: {
          contactMethodType: 4
        },
        process: {}
      },
      contact: {},
      contactMethod: {
        prefix: "+34",
        contactMethodType: 1
      },
      mailContactMethod: {
        contactMethodType: 4
      },
      process: {},
      contactTypes: [
        {
          text: "Particular",
          value: 1
        },
        {
          text: "Emrpresa",
          value: 2
        }
      ],
      phoneContactMethodTypes: [
        {
          text: "Móvil",
          value: 1
        },
        {
          text: "Teléfono",
          value: 2
        }
      ],
      mailContactMethodTypes: [
        {
          text: "Correo",
          value: 4
        }
      ],
      documentTypeTypes: [
        {
          text: "Dni",
          value: 1
        },
        {
          text: "Nie",
          value: 2
        },
        {
          text: "Nif",
          value: 3
        }
      ],
      propertyTypes: [
        {
          text: "Vivienda",
          value: 1
        },
        {
          text: "Local",
          value: 5
        },
        {
          text: "Oficina",
          value: 6
        },
        {
          text: "Finca",
          value: 4
        },
        {
          text: "Garage",
          value: 7
        },
        {
          text: "Otro",
          value: 0
        },
        {
          text: "",
          value: undefined
        }
      ],
      processTypes: [
        {
          text: "Alquiler",
          value: 1
        },
        {
          text: "Compra",
          value: 2
        },
        {
          text: "Alquiler con Opción a Compra",
          value: 3
        },
        {
          text: "Traspaso",
          value: 4
        },
        {
          text: "",
          value: undefined
        }
      ],
      importError: false,
      importSuccessMessage: "",
      importErrorMessage: "",
      terms: "not_accepted"
    };
  },
  created() {
    this.resetForm();
  },
  methods: {
    async importContact() {
      if (this.terms === "accepted") {
        if (this.checkMandatoryFieldsOk()) {
          this.sending = true;
          await ImportRepository.import(
            this.contact,
            this.contactMethod,
            this.mailContactMethod,
            this.process
          )
            .then(() => {
              this.showImportSuccess(
                "Sus datos se han enviado correctamnete. Nos pondremos en contacto en cuanto nos sea posible. Gracias."
              );
              this.resetForm();
            })
            .catch(() => {
              this.showImportError(
                "Se ha producido un error en el envío de datos."
              );
            })
            .finally(() => {
              this.sending = false;
            });
        }
      } else {
        this.showImportError(
          "Aún no ha aceptado los términos de servicio y condiciones"
        );
      }
    },
    resetForm() {
      this.contact = { ...this.defaults.contact };
      this.contactMethod = { ...this.defaults.contactMethod };
      this.mailContactMethod = { ...this.defaults.mailContactMethod };
      this.process = { ...this.defaults.process };
      this.terms = "not_accepted";
    },
    checkMandatoryFieldsOk() {
      let missingFields = [];
      this.mandatoryFields.contact.forEach(field => {
        if (!this.contact[field]) {
          missingFields.push(field);
          this.states[field] = false;
        } else {
          this.states[field] = null;
        }
      });
      let contactMethodMissing = false;
      this.mandatoryFields.contactMethod.forEach(field => {
        if (!this.contactMethod[field]) {
          if (
            !(
              field === "prefix" &&
              this.contactMethod["contactMethodType"] === 4
            )
          ) {
            missingFields.push(field);
            this.states[field] = false;
            contactMethodMissing = true;
          }
        } else {
          this.states[field] = null;
        }
      });
      this.mandatoryFields.mailContactMethod.forEach(field => {
        if (!this.mailContactMethod[field] && contactMethodMissing) {
          missingFields.push(field);
          this.states["mail" + this.capitalize(field)] = false;
        } else {
          this.states["mail" + this.capitalize(field)] = null;
          this.states[field] = null;
          var index = missingFields.indexOf(field);
          if (index > -1) {
            missingFields.splice(index, 1);
          }
        }
      });
      missingFields = this.checkProcessMandatoryFields(missingFields);

      if (missingFields.length) {
        this.showImportError("Faltan campos obligatorios por rellenar");
      }
      return !missingFields.length;
    },
    checkProcessMandatoryFields(missingFields) {
      const missingProcessFields = [];
      this.mandatoryFields.process.forEach(field => {
        if (!this.process[field]) {
          missingProcessFields.push(field);
        } else {
          this.states[field] = null;
        }
      });
      if (missingProcessFields.length !== this.mandatoryFields.process.length) {
        missingProcessFields.forEach(field => {
          missingFields.push(field);
          this.states[field] = false;
        });
      } else {
        this.mandatoryFields.process.forEach(field => {
          this.states[field] = null;
        });
      }
      return missingFields;
    },
    showImportError(message) {
      this.importError = true;
      this.importErrorMessage = message;
      setTimeout(() => {
        this.importErrorMessage = "";
        this.importSuccessMessage = "";
      }, 5000);
    },
    showImportSuccess(message) {
      this.importError = false;
      this.importSuccessMessage = message;
      setTimeout(() => {
        this.importErrorMessage = "";
        this.importSuccessMessage = "";
      }, 5000);
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style lang="scss">
.button-container {
  margin-top: 20px;
}
.btn-send.btn-primary {
  background-color: #0085ca;
  color: #fff;

  width: 120px;
  border: 2px solid #0085ca;

  &:hover {
    color: #0085ca;
    background-color: #fff;
  }
}
.import {
  margin-bottom: 20px;
}
.import-result-displayer-success {
  margin-top: 20px;
  background-color: #00800096;
  color: white;
  border-radius: 5px;
  padding: 10px;
}
.import-result-displayer-error {
  margin-top: 20px;
  background-color: #e55353c2;
  color: white;
  border-radius: 5px;
  padding: 10px;
}
.import-section {
  margin-top: 10px;
}
</style>